import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getAliasClientesActivos`, method: 'GET', body: null, token: token})
}